import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import debounce from 'lodash.debounce';

/**
 * 侧边栏容器
 */
class SidebarContainerStore {
  // 是否展示
  @observable isActive;
  // 侧边栏展示的监听高度, 滚动条达到时进行显隐处理
  @observable showingHeight = 800;

  // 监听滚动条的进度
  onListener = debounce(() => {
    const scrollTop = document.documentElement.scrollTop;
    if (scrollTop >= this.showingHeight) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }, 16);

  use() {
    useMount(() => {
      const onListener = this.onListener;
      window.addEventListener('scroll', onListener);
      return () => {
        window.removeEventListener('scroll', onListener);
      };
    });
  }
}

export default SidebarContainerStore;
